export const BNPL_MIN_TRANSACTION_UNIT_AMOUNT = 5_000;
export const BNPL_MAX_TRANSACTION_UNIT_AMOUNT = 400_000;
